import { Switch, Route } from 'react-router-dom';
import Navbar from 'application/Navbar';
import SearchPage from 'application/pages/SearchPage';
import { useAuth } from 'contexts/AuthContext';
import ApiPage from 'application/pages/ApiPage';
import McpPage from 'application/pages/McpPage';
import UpgradePage from 'application/pages/Upgrade';
import SettingsPage from 'application/pages/Settings';
import SupportPage from 'application/pages/SupportPage';

const AppLayout = () => {
    const { user, loading } = useAuth();

    // Global auth gate: only show full-screen loading when we don't know auth yet (no user).
    // Once we have a user, keep showing the app even during profile refetch (e.g. tab focus / token refresh) so we don't unmount and lose page state.
    if (loading && !user) {
        return (
            <div className="app">
                <div className="content">Loading...</div>
            </div>
        );
    }

    if (!user) {
        // Not authenticated: force user to login/signup before using the app
        window.location.href = '/loginsignup';
        return null;
    }

    return (
        <div className="app">
            <Navbar />
            <div className="content">
                <Switch>
                    <Route exact path="/" component={SearchPage} />
                    <Route path="/search" component={SearchPage} />
                    <Route path="/api" component={ApiPage} />
                    <Route path="/mcp" component={McpPage} />
                    <Route path="/upgrade" component={UpgradePage} />
                    <Route path="/settings" component={SettingsPage} />
                    <Route path="/support" component={SupportPage} />
                </Switch>
            </div>

        </div>
    );
};

export default AppLayout;
